











































import Component from 'vue-class-component'
import Order from '@/modules/order/domain/order'
import { Prop } from 'vue-property-decorator'
import Vue from 'vue'

@Component
export default class OrdersDeliveryPrintDetailTable extends Vue {
  @Prop({ type: Object, required: true }) order!: Order
  @Prop({ type: Number, required: true }) index!: number
  @Prop({ type: Number, required: true }) total!: number
}
